export const NO_DATA_AVAILABLE = 'No Data available';

export const SOMETHING_WENT_WRONG = 'Something went wrong';
